import React from 'react'
import PropTypes from 'prop-types'
import ProgressCircle from './ProgressCircle'
import { Text } from 'components/Box'
import styled from 'styled-components'

import { ReactComponent as Logo } from 'icons/logo.svg'

const progressCircleRadius = 53
const progressContainerSize = progressCircleRadius * 2

const ProgressContainer = styled.div`
  position: relative;
  width: ${progressContainerSize}px;
  height: ${progressContainerSize}px;
  margin: auto;
`

const StyledLogo = styled(Logo).attrs({
  width: '27px',
  height: '25px',
})`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 27px;
  height: 27px;
`

const StyledProgressCircle = styled(ProgressCircle).attrs({
  radius: progressCircleRadius,
})`
  position: absolute;
  top: 0;
  left: 0;
`

const StyledText = styled(Text)`
  color: white;
`

const PrototypeLoader = ({ percentage, onFinished }) => (
  <div>
    <ProgressContainer>
      <StyledLogo />
      <StyledProgressCircle percentage={percentage} onFinished={onFinished} />
    </ProgressContainer>
    <StyledText textAlign="center">Loading prototype…</StyledText>
  </div>
)

PrototypeLoader.propTypes = {
  percentage: PropTypes.number.isRequired,
  onFinished: PropTypes.func,
}

export default PrototypeLoader
